import { createAppSlice } from '@exp/redux/createAppSlice';
import { bindActionCreators } from 'redux';

import { getStoreDiscountAvailable } from '../js/common/api';

const initialState = {
  fetchPending: false,
  lastUpdateTime: null,
  storeDiscountAvailable: null,
};

const storeInformationReducer = createAppSlice({
  name: 'storeInformation',
  initialState,
  reducers: (create) => ({
    fetchStoreDiscountAvailable: create.asyncThunk(
      (storeId) => getStoreDiscountAvailable(storeId),
      {
        pending: (state) => { state.fetchPending = true; },
        fulfilled: (state, action) => {
          state.fetchPending = false;
          state.lastUpdateTime = Date.now();
          state.storeDiscountAvailable = action.payload.data;
        },
        rejected: (state) => {
          state.fetchPending = false;
          state.lastUpdateTime = null;
        },
      },
    ),
  }),
});

export const { fetchStoreDiscountAvailable } = storeInformationReducer.actions;

export const StoreInformationActionsDispatch = (dispatch) => bindActionCreators({
  fetchStoreDiscountAvailable,
}, dispatch);

export default storeInformationReducer.reducer;
